import socketIoAPI from '@/modules/socketAPI.js'
import globalFunctions from '@/packages/globalFunctions.js'

socketIoAPI.onNewConnection(function(socketVar) {
    socketVar.on("meLoggedIn", () => {
        globalFunctions.user.me.getMyData()
    })
})